import PropTypes from 'prop-types'
import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox } from 'legacy/libs/react-form-tools'
import YearSelect from 'legacy/libs/components/year-select'

import { withGettext } from 'lib/gettext'

const YearRangeSelect = createReactClass({
  mixins: [SchemaBranchMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
  },

  schema: {
    yearFrom: null,
    yearTo: null,
    yearFromSign: false,
    yearToSign: false,
  },

  render() {
    const { gettext } = this.props

    return (
      <div className="md:w-[calc(50%_-_1rem)]">
        <label
          className="mb-2 block text-default-light"
          htmlFor="id_create-default_year_covered"
        >
          {gettext('Default year covered')}
        </label>

        <div className="flex space-x-4">
          <ValidationBox
            className="validationbox"
            fieldPath="yearFrom"
            errorMessageClassName="text-danger mt-1 text-xs"
          >
            <YearSelect
              id="id_create-default_year_covered_from"
              classNameMod="_from"
              label={gettext('From')}
              nullable={true}
              signCursor={this.cursors.yearFromSign}
            />
          </ValidationBox>

          <ValidationBox
            className="validationbox"
            fieldPath="yearTo"
            errorMessageClassName="text-danger mt-1 text-xs"
          >
            <YearSelect
              id="id_create-default_year_covered_to"
              classNameMod="_to"
              label={gettext('To')}
              nullable={true}
              signCursor={this.cursors.yearToSign}
            />
          </ValidationBox>
        </div>
      </div>
    )
  },
})

export default withGettext(YearRangeSelect)
